import initMK from '../_core/init.js';
import matreshkaError from '../_helpers/matreshkaerror.js';
import forEach from '../_helpers/foreach.js';
import bindNode from '../bindnode/index.js';
import triggerOne from '../trigger/_triggerone.js';
import getNodes from '../bindnode/_getnodes.js';
import renderedNodes from './_processrendering/renderednodes.js';
import syncFields from './_syncfields.js';
import { addContainer } from './_processrendering/index.js';
import modelCall from './_modelcall.js';
import assign from '../_helpers/assign.js';
// a restored item has no data: a Model made of Matreshka.Array takes it as its items, as in the item mediator
function createModel(Model, parentArray, index) {
  var _Model$prototype;
  var data = (_Model$prototype = Model.prototype) != null && _Model$prototype.isMatreshkaArray ? [] : {};
  modelCall.args = [data, parentArray, index];
  try {
    return new Model(data, parentArray, index);
  } finally {
    modelCall.args = null;
  }
}
// restores Matreshka.Array from external nodes
export default function restore(selector, eventOptions) {
  var _this = this;
  if (eventOptions === void 0) {
    eventOptions = {};
  }
  var selfDef = initMK(this);
  var _syncFields = syncFields(this),
    itemMediator = _syncFields.itemMediator;
  var Model = this.Model;
  var _eventOptions = eventOptions,
    silent = _eventOptions.silent;
  var newItems = [];
  var nodes;
  if (typeof selector === 'string') {
    // get nodes by selector
    nodes = getNodes(this, selector);
  } else {
    // get nodes from rendering container
    var container = this.nodes.container || this.nodes.sandbox;
    if (container) {
      nodes = container.children;
    } else {
      // no container is bound, throw an error
      throw matreshkaError('restore:no_nodes');
    }
  }
  forEach(nodes, function (node, index) {
    var created = Model ? createModel(Model, _this, index) : {}; // create new item
    // the item the array will hold: the mediated one is linked to the node
    var item = itemMediator ? itemMediator(created, index) : created;
    var bindRenderedAsSandbox = item.bindRenderedAsSandbox;
    var itemDef = initMK(item);
    itemDef.renderedInArrays = {};
    itemDef.renderedInArrays[selfDef.id] = node;
    renderedNodes.set(node, true);
    // the array owns the restored nodes: a forced rerender takes them out of where they are
    if (node.parentNode) {
      addContainer(selfDef, node.parentNode);
    }
    if (bindRenderedAsSandbox !== false) {
      bindNode(item, 'sandbox', node, null, eventOptions);
    }
    if (!silent) {
      // trigger needed events
      var itemEventOptions = {
        node: node,
        self: item,
        parentArray: _this
      };
      var onRender = item.onRender;
      var onItemRender = _this.onItemRender;
      if (onRender) {
        onRender.call(item, itemEventOptions);
      }
      if (onItemRender) {
        onItemRender.call(_this, item, itemEventOptions);
      }
      triggerOne(item, 'render', itemEventOptions);
      // call afterrender immediately because a node already exists in DOM tree
      triggerOne(item, 'afterrender', itemEventOptions);
    }
    newItems.push(item);
  });
  // recreate an array but don't render newly added items
  return this.recreate(newItems, assign({
    dontRender: true
  }, eventOptions, {
    skipItemMediator: true
  }));
}